<template>
  <v-card outlined elevation="0" style="border: none">
    <v-card-title>
      <h3>{{ workorder.description }} ({{ workorder.wonum }})</h3>
    </v-card-title>
    <v-card-text class="pt-1">
      <v-row class="px-1 mb-1">
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.pageKm.loco", { value: "default" }) }}:</span
            >
            <span class="value">{{ workorder.topLevel }}</span>
          </div>

          <div>
            <span class="mtitle">Asset :</span>
            <span class="value">{{ workorder.assetnum }}</span>
          </div>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.location", { value: "default" }) }} :</span
            >
            <span class="value">{{ workorder.locationdesc }}</span>
          </div>
        </v-col>
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.status", { value: "default" }) }} :</span
            >
            <span class="value">{{
              this.$t("message.woStatus." + workorder.status, {
                value: "default",
              })
            }}</span>
          </div>

          <div>
            <span class="mtitle"
              >{{ $t("message.magic.type", { value: "default" }) }} :</span
            >
            <span class="value">{{ workorder.worktype }}</span>
          </div>
          <div v-if="workorder.worktype == 'PM'" >
            <span class="mtitle"
              >{{ $t("message.magic.jobplan", { value: "default" }) }} :</span
            >
            <span class="value">{{ workorder.type }}</span>
          </div>

          <!--<div v-if="workorder.billable == 1" >
            <span class="value">prestation hors contrat</span>
          </div>-->

        </v-col>
      </v-row>
      <v-divider class="mb-4"></v-divider>

      <v-row class="px-2 mb-2">
        <v-col>
          <div>
            <span class="mtitle"
              ><b>{{
                $t("message.magic.scheduleDate", { value: "default" })
              }}</b>
            </span>
          </div>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.startDate", { value: "default" }) }} :</span
            >
            <span class="value">{{ formatdate(workorder.schedstart) }}</span>
          </div>

          <div>
            <span class="mtitle"
              >{{ $t("message.magic.endDate", { value: "default" }) }} :</span
            >
            <span class="value">{{ formatdate(workorder.schedfinish) }}</span>
          </div>
          <div>
            <span class="mtitle"
              ><b>{{
                $t("message.magic.executeDate", { value: "default" })
              }}</b>
            </span>
          </div>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.startDate", { value: "default" }) }} :</span
            >
            <span class="value">{{ formatdate(workorder.actstart) }}</span>
          </div>

          <div>
            <span class="mtitle"
              >{{ $t("message.magic.endDate", { value: "default" }) }} :</span
            >
            <span class="value">{{ formatdate(workorder.actfinish) }}</span>
          </div>
        </v-col>
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.magic.desc", { value: "default" }) }} :</span
            >
          </div>

          <div>
            <span class="value">{{ filterHtml(workorder.ldescription) }}</span>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mb-1" v-if="showProtocol()"></v-divider>

      <v-row class="px-2 mb-2" v-if="showProtocol()">
        <v-col>
          <div>
            <span class="mtitle"> Protocol </span>
          </div>
          <div>
            <v-data-table
              dense
              :headers="headersProtocol"
              :items="protocols"
              light
            >
              <template v-slot:[`item.createdate`]="{ item }">
                {{ formatdate(item.createdate) }}
              </template>
              <template
                v-slot:[`item.document`]="{ item }"
                @click="downloadProtocol(item)"
              >
                {{ item.documentName }}
                <v-icon @click="downloadProtocol(item)"> mdi-download</v-icon>
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mb-1" v-if="showAlert()"></v-divider>

      <v-row class="px-2" v-if="showAlert()">
        <v-col>
          <div>
            <span class="mtitle">
              {{ $t("message.magic.srAttechement", { value: "default" }) }}
            </span>
          </div>
          <div>
            <v-data-table dense :items="srs" :headers="headerSrTable" class="">
              <template v-slot:[`item.reportdate`]="{ item }">
                {{ formatdate(item.reportdate) }}
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <span v-html="item.description"></span> </template
            ></v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { formatMagicDate } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";
export default {
  props: ["workorder", "protocols", "srs"],

  data() {
    return {};
  },
  methods: {
    showProtocol() {
      if (this.protocols.length > 0) {
        return true;
      }
      return false;
    },

    showAlert() {
      if (this.srs.length > 0) {
        return true;
      }
      return false;
    },
    formatdate(date) {
      return formatMagicDate(date);
    },

    downloadProtocol(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);

      window.open(file_path);
    },
    filterHtml(value) {
      if(value){
        let regex = /(<([^>]+)>)/ig;
        return value.replace(regex, "");
      }
    },
  },
  computed: {
    headersProtocol() {
      return [
        {
          text: this.$t("message.magic.date", { value: "default" }),
          value: "createdate",
        },
        {
          text: this.$t("message.magic.details", { value: "default" }),
          value: "document",
        },
      ];
    },

    headerSrTable() {
      return [
        {
          text: this.$t("message.magic.id", { value: "default" }),
          value: "ticketid",
          sortable: true,
        },
        {
          text: this.$t("message.magic.description", { value: "default" }),
          value: "description",
          sortable: true,
        },
        {
          text: this.$t("message.magic.status", { value: "default" }),
          value: "status",
          sortable: true,
        },
        {
          text: this.$t("message.magic.date", { value: "default" }),
          value: "reportdate",
          sortable: true,
        },
      ];
    },
  },
};
</script>

<style scoped>
.dp {
  color: #00475a;
  font-weight: bolder;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #fff;
  font-size: 16px;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bolder;
}

.value {
  font-size: 16px;
}
</style>
